import styles from "./MenuItem.module.scss";
import { Link } from "../../../../ui-kit/Link/Link";
import { useLocation } from "react-router-dom";
import { classNames } from "../../../../utils/classNames";

export const MenuItem = ({ label, platform, href = "", subItems = [] }) => {
  const location = useLocation();
  const isCurrentRoute = location.pathname == href;
  return (
    <div
      className={classNames(styles.item, styles["active--" + isCurrentRoute])}>
      {href === "/dharma" && (
        <Link
          href={href}
          large={platform === 'web'}
          big={platform === 'mobile'}
          medium
          color={!isCurrentRoute ? "white-50" : "white"}
          style={platform === 'mobile' && {textAlign: 'center'}}
        >
          {label}
        </Link>
      )}
      {href === "/contacts" && (
        <Link
          href={"https://www.dh1937.ru/napisat-nam"}
          large={platform === 'web'}
          big={platform === 'mobile'}
          medium
          color={!isCurrentRoute ? "white-50" : "white"}
          style={platform === 'mobile' && {textAlign: 'center'}}
        >
          {label}
        </Link>
      )}
      {href === "/articles" && (
        <Link
          href={href}
          large={platform === 'web'}
          big={platform === 'mobile'}
          medium
          color={!isCurrentRoute ? "white-50" : "white"}
          style={platform === 'mobile' && {textAlign: 'center'}}
        >
          {label}
        </Link>
      )}
      {href === "/zins" && (
        <Link
          href={"https://www.dh1937.ru/zine"}
          large={platform === 'web'}
          big={platform === 'mobile'}
          medium
          color={!isCurrentRoute ? "white-50" : "white"}
          style={platform === 'mobile' && {textAlign: 'center'}}
        >
          {label}
        </Link>
      )}


    </div>
  );
};
